import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'

import FlagStatus from '../../components/nftInfo/FlagStatus'

const Card = styled.div<{bg?: string}>`
  position: relative;
  background: ${({bg, theme}) => bg ? bg : theme.bsBg2};
  border-radius: 29px;
  color: #FFFDFA;
  font-family: Baloo Da;
  height: 100%;
`
const ImgWrapper = styled.div<{headerHeight?: number}>`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: ${({ headerHeight }) => headerHeight ? 170 : 110 }px;
`
const Footer = styled.div<{bg?: string}>`
  position: relative;
  background: ${({bg, theme}) => bg ? bg : theme.bsBg2};
  border-bottom-left-radius: 29px;
  border-bottom-right-radius: 29px;
`
const Items = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({theme}) => theme.bsBg4};
  border-radius: 50%;
  color: ${({theme}) => theme.bsText5};
  width: 58px;
  height: 58px;
`
const ItemsNum = styled(Text)`
  color: ${({theme}) => theme.bsText6};
  line-height: 26px;
`
const LevelWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 10px;
  display: flex;
`


export default function PlateCard(
  {dish, ids, headerHeight, iconUrl, items, isExchange, level, 
    isShowFlag, smallLevelIcon, children, bidFlag, auctionPrice, levelType, bg,isMydish
  }: 
  { dish?: any, ids?: any, price?: number, headerHeight?: number, iconUrl: string, 
    items?: number, level?:number, smallLevelIcon?:boolean, bidFlag?: boolean, 
    isShowFlag?: boolean, isExchange?: boolean, auctionPrice?: string , 
    levelType?: string, children: React.ReactNode,bg?:string , isMydish?: boolean
  }) {
  const theme = useContext(ThemeContext)
  return (
    <Card bg={bg}>
      <FlagStatus artwork={dish} ids={ids} isMyArtwork={isMydish}  />
      <ImgWrapper headerHeight={headerHeight}>
        <img src={iconUrl} alt=""/>
      </ImgWrapper>
      <Footer bg={bg}>
        {
          level !== undefined ? (
            <LevelWrapper>
              {
                Array.from(Array(Number(level)).keys()).map((d) => {
                  return <img key={d} src={'/images/nft/icon_levelstar' + (theme.darkMode ? '_light' : '') + '.svg'} alt='level-star' width={smallLevelIcon ? 16 : 32} height={smallLevelIcon ? 16 : 32} />
                })
              }
            </LevelWrapper>
          ) : null
        }
        {
          !!items && <Items>
            <ItemsNum fontSize={26}>{items}</ItemsNum>
            <Text fontSize={12} lineHeight={'12px'}>Items</Text>
          </Items>
        }
        {children}
      </Footer>
    </Card>
  )
}